import type { ReactNode } from 'react';

export function KpiCard({
  label,
  value,
  tone,
  hint,
}: {
  label: string;
  value: ReactNode;
  tone?: 'pass' | 'fail';
  hint?: string;
}) {
  const toneClass =
    tone === 'fail' ? 'kpi-card__value--fail' : tone === 'pass' ? 'kpi-card__value--pass' : '';
  return (
    <div className="glass-panel kpi-card">
      <span className="kpi-card__label">{label}</span>
      <span className={`kpi-card__value ${toneClass}`}>{value}</span>
      {hint && (
        <span style={{ fontSize: 'var(--font-size-xs)', color: 'var(--color-text-muted)' }}>
          {hint}
        </span>
      )}
    </div>
  );
}
